import { createSearchParams } from 'react-router-dom';
import { getApplicationPrefilterByKey } from './applicationPrefilters';
import { withDashboardBreadcrumbOrigin } from './breadcrumbNavigation';

/**
 * Navigate to the applications list with query/state derived from dashboard chart keys
 * (same behavior as AdminReport drill-downs).
 */
export function navigateApplicationsFromDashboardFilter(navigate, dashboardFilter) {
  const prefilter = getApplicationPrefilterByKey(dashboardFilter);
  const params = {};
  if (prefilter?.selectedStage?.length) params.stage = prefilter.selectedStage.join(',');
  if (prefilter?.selectedAppType?.length) params.appType = prefilter.selectedAppType.join(',');
  if (!prefilter && typeof dashboardFilter === 'string' && dashboardFilter.trim()) {
    params.stage = dashboardFilter;
  }
  const search = createSearchParams(params).toString();
  navigate(search ? `/property/applications?${search}` : '/property/applications', {
    state: withDashboardBreadcrumbOrigin({ dashboardFilter }),
  });
}
